import React from 'react';

const DashBoard = () => {
    return (
        <div>
            <h2>DashBoard</h2>
        </div>
    );
};

export default DashBoard;